import type { IFieldValidationParams } from '../validation.types';
import { ValidationErrorType } from '../validation.types';

const SPACE_ALIAS_MIN_LENGTH = 2;
const SPACE_ALIAS_REGEXP = /^[a-zA-Z0-9-_]+$/;

export const spaceAliasCreateValidation = ({
  value,
  errorToText,
}: IFieldValidationParams): string | null => {
  if (value?.length > 0 && value?.length < SPACE_ALIAS_MIN_LENGTH) {
    return errorToText[ValidationErrorType.TooShort] || '';
  }

  if (!SPACE_ALIAS_REGEXP.test(value)) {
    return errorToText[ValidationErrorType.IncorrectSymbols] || '';
  }

  return null;
};

export const spaceAliasEditValidation = ({
  value,
  errorToText,
}: IFieldValidationParams): string | null => {
  if (!value || value.length === 0) {
    return errorToText[ValidationErrorType.Empty] || '';
  }

  return spaceAliasCreateValidation({ value, errorToText });
};
